module.exports = __webpack_public_path__ + "assets/img/banner-16.a5e101df.jpg";